import type { StyleRule } from '@archipro-design/aria';
import { buttonClassName } from '@archipro-design/aria';

export const CurrentTag: StyleRule = () => ({
    [`&.${buttonClassName}`]: {
        position: 'absolute',
    },
});

export const SearchModalContainer: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.menuItem + 1, // make sure it's above the resene menu
});
